
import {Component, Vue} from "vue-property-decorator";
import {NotAyariEntity} from "@/entity/NotAyariEntity";

/**
 * DEV-1263 — Tercihler > Not Ayarları.
 *
 * Tek bir boolean tercih olduğu için ayrı bir FormDialog/DeleteDialog kurgusu yok;
 * switch doğrudan kaydediyor. Ayar OFİS (kiracı) genelindedir, kullanıcı başına değil —
 * Tercihler ekranındaki diğer kartların tamamı da öyle.
 *
 * Bu bileşen sistem notunu ÜRETMEZ, yalnızca tercihi okur/yazar. Notu yazan tek yer
 * API'deki TakipAcilisNotuService'tir.
 */
@Component
export default class NotAyarlariList extends Vue {
  ayar: NotAyariEntity = new NotAyariEntity();
  yukleniyor = false;

  get duzenleyebilir(): boolean {
    return this.$helper.isAuthorized('not-ayarlari-duzenle');
  }

  mounted() {
    this.yukle();
  }

  yukle() {
    this.yukleniyor = true;
    this.$http.get("/api/v1/not-ayari").then((response: any) => {
      const veri = response.data?.data ?? response.data;
      if (veri) {
        this.ayar = Object.assign(new NotAyariEntity(), veri);
      }
    }).catch((error: any) => {
      console.error('Not ayarı okunamadı:', error);
    }).finally(() => {
      this.yukleniyor = false;
    });
  }

  kaydet(deger: boolean) {
    this.yukleniyor = true;
    // Content-Type ACIKCA veriliyor: uygulama genelinde axios varsayilani
    // 'application/x-www-form-urlencoded' (src/plugins/axios.ts) ama govde JSON olarak
    // gonderiliyor. Basligi duzeltmezsek sunucu govdeyi form verisi sanip boolean'i
    // okuyamayabilir ve ayar sessizce yanlis kaydedilir.
    this.$http.post(
        "/api/v1/not-ayari",
        {takip_acilis_notu_ekle: deger},
        {headers: {'Content-Type': 'application/json'}}
    ).then((response: any) => {
      const veri = response.data?.data ?? response.data;
      if (veri) {
        this.ayar = Object.assign(new NotAyariEntity(), veri);
      }
    }).catch((error: any) => {
      console.error('Not ayarı kaydedilemedi:', error);
      // Sunucu reddettiyse anahtarı geri al — kullanıcı sahte bir başarı görmesin.
      this.ayar.takip_acilis_notu_ekle = !deger;
    }).finally(() => {
      this.yukleniyor = false;
    });
  }
}
